/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcPaymentsV1WireEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PAYMENTS_V1_WIRE_EVENT_ENTITY_NAME = 'ixc.payments.v1.WireEvent';
export const ixcPaymentsV1WireEventEntity = new schema.Entity<IxcPaymentsV1WireEvent>(IXC_PAYMENTS_V1_WIRE_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcPaymentsV1WireEvent) => `${entity.metadata?.eventId}` });

